export default __webpack_public_path__ + "static/media/AdStorm_09.67215caa.png";